import React, { useState } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import Juicer from "../../../../../assets/images/OUR SERVICES/juicer.png";
import orange from "../../../../../assets/images/OUR SERVICES/orange.png";
import mango from "../../../../../assets/images/OUR SERVICES/mango.png";
import nimbu from "../../../../../assets/images/OUR SERVICES/nimbu.png";
import kokam from "../../../../../assets/images/OUR SERVICES/kokam.png";
import pinapple from "../../../../../assets/images/OUR SERVICES/pinapple.png";
import liquids from "../../../../../assets/images/OUR SERVICES/Liquid Break Banner.png";
import EnquiryModal from '../../../../../common/pages/enquiryModal';
const Juicers = () => {
    const [modal, setModal] = useState(false);
    const toggleModal = () => setModal(!modal);
    return (
        <React.Fragment>

            <section className="section bg-light py-5" id="features">
                <Container>
                    <Row className="align-items-center gy-4">
                        <div className="text-muted">
                            <div className="text-center ">
                                <h2 className="fw-bold mt-5" style={{ fontSize: "2rem", color: "#F15A29" }}>Juice Dispenser</h2>

                            </div>
                        </div>
                    </Row>
                </Container>
            </section>

            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10} sm={10}>
                            <Row className="align-items-center gy-4">
                                <img
                                    src={liquids}
                                    alt="Premium Corporate Gifts"
                                    className="img-fluid rounded"
                                    style={{ width: "100%", height: "auto" }}
                                />
                            </Row>

                            <Row className="align-items-center gy-4 mt-4">
                                <Col lg={6} md={12}>
                                    <img
                                        src={Juicer}
                                        alt="Premium Corporate Gifts"
                                        className="img-fluid rounded"
                                        style={{ width: "100%", height: "auto" }}
                                    />
                                </Col>
                                <Col lg={6} md={12}>

                                    <div className="text-black">
                                        {/* <p><strong>Built-in Chillers</strong> – Keep beverages cool and refreshing all day with integrated chilling technology.</p> */}
                                        <p><strong>Promotes Hydration</strong> – Keep your team energized and refreshed all day — a delicious way to stay hydrated without the boring water bottle routine.</p>
                                        <p><strong>Half the Cost of Tea or Coffee</strong> - Get all the flavor at half the spend — a smart sip that saves money while boosting morale.</p>
                                        <p><strong>No Electricity Needed </strong> - Unplug and pour — our dispensers run without electricity, making them eco-friendly and setup-easy anywhere, anytime. </p>
                                        <p><strong>Iconic Indian Flavours</strong> – Enjoy nostalgic, regional favorites that keep everyone hydrated and happy.</p>
                                        <p><strong>Perfect for All Setups</strong> – Whether it's a startup or a corporate office, our dispensers fit seamlessly into any space.</p>
                                        <p><strong>Easy Setup & Fast Delivery</strong> – Seamless process to get your dispenser running without delays.</p>
                                        <p><strong>Vibrant Syrup Flavours</strong> – Available in 5 Signature Flavours:</p>
                                        <ul>
                                            <li>🌿 Kokam</li>
                                            <li>🍊 Orange</li>
                                            <li>🥭 Aam Panna</li>
                                            <li>🍋 Nimbu Pani</li>
                                            <li>🍍 Pineapple</li>

                                        </ul>
                                    </div>

                                </Col>

                            </Row>
                            <Row className="align-items-center gy-4">

                                <Col lg={6} md={12}>

                                    <div className="text-black">
                                        <p><strong>Trophical Kokam</strong> </p>
                                        <p>Escape to the Konkan coast with every deep crimson pour.</p>
                                        <p> Liquidbreak Kokam Syrup is your passport to a chilled, tangy getaway—bold, refreshing, and rooted in tradition.</p>
                                        <p> Tart meets sweet. Spice meets serenity.</p>
                                        <p>It’s more than a drink—it’s a feeling.</p>

                                    </div>

                                </Col>
                                <Col lg={6} md={12}>
                                    <img
                                        src={kokam}
                                        alt="Premium Corporate Gifts"
                                        className="img-fluid rounded"
                                        style={{ width: "70%", height: "auto" }}
                                    />
                                </Col>

                            </Row>
                            <Row className="align-items-center gy-4">
                                <Col lg={6} md={12}>
                                    <img
                                        src={orange}
                                        alt="Premium Corporate Gifts"
                                        className="img-fluid rounded"
                                        style={{ width: "70%", height: "auto" }}
                                    />
                                </Col>
                                <Col lg={6} md={12}>

                                    <div className="text-black">



                                        <p><strong>Poppin’ Orange</strong></p>
                                        <p>Escape to a tropical paradise with every pour—where zesty oranges meet a swirl of sweet and salty magic.</p>
                                        <p>This vibrant blend of citrus goodness delivers an instant burst of energy and refreshment.</p>
                                        <p>One sip = vacation mode on.</p>
                                        <p>Ideal for dispensers or simply served chilled — all year round.</p>

                                    </div>

                                </Col>

                            </Row>
                            <Row className="align-items-center gy-4">

                                <Col lg={6} md={12}>

                                    <div className="text-black">
                                        <p><strong>Sour meets sweet</strong> </p>
                                        <p> Escape into the ultimate summer rewind with Liquidbreak Aam Panna Syrup—crafted with real raw mango pulp, a dash of spice, and a whisper of cardamom.</p>
                                        <p>It’s hydration with heritage, refreshment with attitude.</p>
                                        <p>Easy to serve, enjoyable all year round.</p>

                                    </div>

                                </Col>
                                <Col lg={6} md={12}>
                                    <img
                                        src={mango}
                                        alt="Premium Corporate Gifts"
                                        className="img-fluid rounded"
                                        style={{ width: "70%", height: "auto" }}
                                    />
                                </Col>

                            </Row>
                            <Row className="align-items-center gy-4">
                                <Col lg={6} md={12}>
                                    <img
                                        src={nimbu}
                                        alt="Premium Corporate Gifts"
                                        className="img-fluid rounded"
                                        style={{ width: "70%", height: "auto" }}
                                    />
                                </Col>
                                <Col lg={6} md={12}>



                                    <div className="text-black">
                                        <p><strong>Desi Limbu Pani</strong> </p>
                                        <p>Let the tang transport you to a breezy beach shack—where lemons are bold, the salt hits just right, and the energy is effortless.</p>
                                        <p>This iconic Indian cooler gets a tropical remix, blending tradition with escape-in-a-bottle freshness.</p>
                                        <p>Recharge. Refresh. Reimagine.</p>

                                    </div>

                                </Col>

                            </Row>
                            <Row className="align-items-center gy-4">

                                <Col lg={6} md={12}>



                                    <div className="text-black">
                                        <p><strong>Golden Drops of Paradise</strong></p>
                                        <p>Step into the sunshine.</p>
                                        <p>Pineapple Syrup brings you island feels in every glass—bold, juicy, and unapologetically tropical.</p>
                                        <p>It's that perfect blend of sweet tang and chill, bottled for your everyday escape.</p>
                                        <p>One sip, and you're dancing in a hammock under palm trees.</p>

                                    </div>
                                </Col>
                                <Col lg={6} md={12}>
                                    <img
                                        src={pinapple}
                                        alt="Premium Corporate Gifts"
                                        className="img-fluid rounded"
                                        style={{ width: "70%", height: "auto" }}
                                    />
                                </Col>

                            </Row>

                        </Col>
                    </Row>


                    <div style={{ overflow: "hidden", whiteSpace: "nowrap", backgroundColor: "#34519f" }}>
                        <div
                            style={{
                                display: "inline-block",
                                color: "white",
                                fontWeight: "bold",
                                fontSize: "20px",
                                padding: "10px 0",
                                animation: "scroll-left 20s linear infinite"
                            }}
                        >
                            <span style={{ paddingRight: "50px" }}>
                                • Liquidbreak Syrups — Powered by Offiso India
                            </span>
                            <span style={{ paddingRight: "50px" }}>
                                • Liquidbreak Syrups — Powered by Offiso India
                            </span>
                            <span style={{ paddingRight: "50px" }}>
                                • Liquidbreak Syrups — Powered by Offiso India
                            </span>
                            <span style={{ paddingRight: "50px" }}>
                                • Liquidbreak Syrups — Powered by Offiso India
                            </span>
                        </div>

                        <style>
                            {`
                                @keyframes scroll-left {
                                    0% {
                                    transform: translateX(0%);
                                    }
                                    100% {
                                    transform: translateX(-50%);
                                    }
                                }
                             `}
                        </style>
                    </div>


                </Container>
                <EnquiryModal isOpen={modal} toggle={toggleModal} />
            </section>
            <section className="section  py-5" style={{ backgroundColor: " rgb(52, 81, 159)" }} id="features">
                <Container>
                    <Row className="justify-content-center">
                        <div className='text-center '>
                            <Button className='px-4 py-2 fw-bold' onClick={toggleModal}
                                style={{ background: "rgb(238, 99, 82)", borderRadius: "20px", color: "white", fontSize: "20px" }}
                            >
                                Enquiry Now
                            </Button>
                        </div>
                    </Row>
                </Container>
            </section>
        </React.Fragment >
    );
};

export default Juicers;